export default {
  locoScroll: undefined,
  nextContainer: undefined
}
